import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserStorage } from './../../helper';
import { Roles } from './../../model';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent {

  userName = this.user.getLocalUserEmail().substring(0, this.user.getLocalUserEmail().indexOf('@'));
  isAdmin = this.user.isAdmin();
  isEngineer = this.user.isEngineer();
  isTechnician = this.user.isTechnician();
  constructor(
    private router: Router,
    private translate: TranslateService,
    private user: UserStorage
  ) {
    translate.setDefaultLang('en-us');
  }

  public logout() {
    this.user.signOut();
    this.router.navigate(['./']);
  }

  public isAdminRole() {
    return this.user.getLocalUserRole() === Roles.Admin;
  }

  public toProfile() {
    // if (this.isAdmin) {
      // const id = this.user.getLocalUserID();
      // this.router.navigate(['/home/users/detail/' + id]);
      this.router.navigate(['/home/my-profile']);
    // }
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/components/app-header/app-header.component.ts